<nz-card nzTitle="Construction Log">
  <ng-container *ngIf="error$ | async as errorMsg; else constructionLogsTemplate">
    <em-error-result [subTitle]="errorMsg"></em-error-result>
  </ng-container>
</nz-card>

<ng-template #longTextTemplate let-longText>
  <pre>{{ longText }}</pre>
</ng-template>

<ng-template #constructionLogsTemplate>
  <nz-skeleton [nzActive]="true" [nzLoading]="(loading$ | async) ?? false">
    <div nz-row nzJustify="space-between" nzAlign="middle">
      <nz-checkbox-group
        nz-col
        [nzOptions]="checkOptions"
        [(ngModel)]="selectedEntryTypes"
        (ngModelChange)="updateSelected()"
      ></nz-checkbox-group>

      <nz-select
        nz-col
        class="notification-code-filter"
        [nzLoading]="areEntryCodesLoading"
        nzMode="multiple"
        [nzAllowClear]="true"
        [nzFilterOption]="entryCodeFilter"
        [formControl]="entryCodesControl"
        nzPlaceHolder="Filter on codes"
      >
        <nz-option
          nzCustomContent
          *ngFor="let option of entryCodes$ | async; trackBy: trackByRef"
          [nzLabel]="option.code"
          [nzValue]="option"
        >
          <div>{{ option.code }} - {{ option.text }}</div>
        </nz-option>
      </nz-select>
    </div>

    <nz-divider></nz-divider>

    <nz-table
      #constructionLogTable
      [nzData]="(pagination$ | async)?.data ?? []"
      [nzLoading]="(paginatorRef.loading$ | async) ?? false"
      [nzFrontPagination]="false"
      [nzPageSizeOptions]="[5, 10, 20, 30]"
      nzSize="small"
      [nzPageSize]="perPage"
      [nzPageIndex]="pageIndex"
      (nzPageSizeChange)="pageSizeChange($event)"
      (nzPageIndexChange)="paginatorRef.setPage($event)"
      nzShowSizeChanger
      [nzTotal]="(pagination$ | async)?.total ?? 0"
    >
      <thead>
        <tr>
          <th>Log date</th>
          <th>Code</th>
          <th>Status text</th>
          <th>Short text</th>
          <th>User</th>
          <th>Long text</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let constructionLog of constructionLogTable.data; trackBy: trackByRef">
          <td>
            <em-display-property
              [value]="(constructionLog.createdDate | date: 'shortDate') ?? ''"
            ></em-display-property>
          </td>
          <td>
            <em-display-property [value]="constructionLog.partOfObject ?? ''"></em-display-property>
          </td>
          <td>
            <em-display-property
              [value]="constructionLog.causeShortText ?? ''"
            ></em-display-property>
          </td>
          <td>
            <em-display-property [value]="constructionLog.shortText ?? ''"></em-display-property>
          </td>
          <td>
            <em-display-property [value]="constructionLog.createdBy ?? ''"></em-display-property>
          </td>
          <td>
            <button
              *ngIf="constructionLog.longTextAvailable"
              (click)="showLongText(constructionLog.longText ?? '')"
              nz-button
              nzType="link"
            >
              <i nz-icon nzType="file-text" nzTheme="twotone" nzTwotoneColor="5914fa"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-skeleton>
</ng-template>
